<template>
	<div>
		<a-table  size="small" :columns="columns" :data-source="list" bordered :loading="loading"  rowKey="pid" :pagination="false"  :scroll="{y:500}">
			<span slot="mainMeterSlot"  slot-scope="text, record">
				{{record.mainMeter ==1 ? '有' : '无'}}
			</span>
			<span slot="timerSwitchSlot" slot-scope="text, record">
				{{record.timerSwitch ==1 ? '开' : '关'}}
			</span>
			<span slot="timeSlot" slot-scope="text, record">
				{{getTimeFormatter(record.createTime)}}
			</span>
		</a-table>
	</div>
</template>

<script>
	const  columns = [
			{
				title: '小区名',
				dataIndex: 'neighborName',
				width:160,
				ellipsis:true,
				className:'v-cell',
				align:'center',
			},
			{
				title: '地址',
				dataIndex: 'neighborAddr',
				width:160,
				ellipsis:true,
				className:'v-cell',
				align:'center',
			},
			{
				title: '管理表',
				dataIndex: 'mainMeter',
				width:80,
				align:'center',
				scopedSlots: { customRender: 'mainMeterSlot' },
				className:'v-cell',
				align:'center',
			},
			{
				title: '定时抄表开关',
				dataIndex: 'timerSwitch',
				width:120,
				align:'center',
				scopedSlots: { customRender: 'timerSwitchSlot' },
				className:'v-cell',
				align:'center',
			},
			{
				title: '定时抄表时间',
				dataIndex: 'timer',
				width:130,
				className:'v-cell',
				align:'center',
			},
			{
				title: '抄表IP',
				dataIndex: 'ip',
				width:120,
				className:'v-cell',
				align:'center',
			},
			{
				title: '备注',
				dataIndex: 'remark',
				width:150,
				ellipsis:true,
				className:'v-cell',
				align:'center',
			},
			{
				title: '创建时间',
				dataIndex: 'createTime',
				width:130,
				scopedSlots:{customRender:'timeSlot'},
				className:'v-cell',
				align:'center',
			},
	];
	export default{
		data(){
			return {
				columns,
				loading:true,
				list:[],
			}
		},
		methods:{
			getTimeFormatter:function(dateTime){
				if(dateTime == null){
					return "";
				}else{
					let date = new Date(dateTime);
					return this.Config.formatDate(date);
				}
			},
			getLastestNeighbor:function(departmentId){
				let url = this.Api.getLastUrl(this.Api.NEIGHBOR_LASTEST_LIST_URL);
				let param = {departId:departmentId};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					this.loading = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.list = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.loading = false;
					console.log(error);
				});
			},
		},
		created() {
			this.getLastestNeighbor(this.Config.getUserLocal().departmentId);
		}
	}
	
	
	
</script>

<style>
</style>
